/**
 * tdesign v1.11.1
 * (c) 2025 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-8bcc0e9b.js';
import { _ as _objectWithoutProperties } from '../_chunks/dep-1978af39.js';
import React from 'react';
import classNames from 'classnames';
import useConfig from '../hooks/useConfig.js';
import useDefaultProps from '../hooks/useDefaultProps.js';
import '../_chunks/dep-6b7c7d34.js';
import '../_chunks/dep-248ede8a.js';
import '../config-provider/ConfigContext.js';
import 'lodash-es';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-35c2a089.js';
import '../_chunks/dep-fad4e87b.js';
import 'dayjs';
import '../_chunks/dep-81c9c3a2.js';
import '../_common/js/global-config/default-config.js';

var _excluded = ["width", "className", "style", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Aside = function Aside(props) {
  var _useDefaultProps = useDefaultProps(props, {
      width: 232
    }),
    width = _useDefaultProps.width,
    className = _useDefaultProps.className,
    style = _useDefaultProps.style,
    children = _useDefaultProps.children,
    otherAsideProps = _objectWithoutProperties(_useDefaultProps, _excluded);
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var asideClassNames = classNames("".concat(classPrefix, "-layout__sider"), className);
  var asideWidth = isNaN(Number(width)) ? width : "".concat(width, "px");
  var asideStyle = _objectSpread({
    width: asideWidth,
    maxWidth: asideWidth,
    minWidth: asideWidth,
    flex: "0 0 ".concat(asideWidth)
  }, style);
  return /* @__PURE__ */React.createElement("aside", _objectSpread({
    className: asideClassNames,
    style: asideStyle
  }, otherAsideProps), children);
};
Aside.displayName = "Aside";

export { Aside as default };
//# sourceMappingURL=Aside.js.map
